import { type AiNotification } from 'clients/CallhomeApiTypes';
import * as EventClient from 'clients/EventClient';
import useSWR from 'swr';
import { DAY_IN_MILLISECONDS } from 'vd-constants';

export function useEventSpotCheckMonthlyUsages(eventSpotChecks: AiNotification[]) {
  const { data, error, isLoading } = useSWR(
    eventSpotChecks?.length ? ['eventSpotCheckUsages', eventSpotChecks] : null,
    async () => {
      const dateRangeLastThirtyDays = getDateRangeLastThirtyDays();
      const results = await Promise.all(
        eventSpotChecks.map((eventSpotCheck) =>
          EventClient.fetchEventsBetween(
            {
              selectedReportId: eventSpotCheck?.reportTemplateId,
            },
            dateRangeLastThirtyDays,
            { totalLimit: false },
          ).then((result) => ({
            id: eventSpotCheck?.id,
            total: result.total,
          })),
        ),
      );

      return results.reduce(
        (acc, { id, total }) => {
          if (id) acc[id] = total;
          return acc;
        },
        {} as Record<string, number>,
      );
    },
  );

  return {
    monthlyUsages: data,
    error,
    loading: isLoading,
  };
}
function getDateRangeLastThirtyDays() {
  const currentTime = Date.now();
  return {
    start: currentTime - 30 * DAY_IN_MILLISECONDS,
    end: currentTime,
  };
}
